import { MessageCircle, User, LogOut, Menu, X } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Logo } from './Logo';

export function Header() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, isAdmin, isCustomer, signOut } = useAuth();

  const whatsappNumber = '213776043917';
  const whatsappMessage = encodeURIComponent(
    'Bonjour, je suis intéressé par une location à Oran. Pourriez-vous me donner plus d\'informations sur vos offres disponibles ? Merci !'
  );
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Logo />

          <div className="flex items-center space-x-3 md:space-x-6">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Nous contacter sur WhatsApp"
              className="flex items-center space-x-1 md:space-x-2 bg-green-500 text-white px-3 md:px-4 py-2 rounded-lg hover:bg-green-600 transition font-medium"
            >
              <MessageCircle size={20} />
              <span className="hidden sm:inline">WhatsApp</span>
            </a>

            <div className="hidden md:flex items-center space-x-6">

              {!user && (
                <>
                  <button
                    onClick={() => navigate('/login')}
                    className="flex items-center space-x-1 text-gray-700 hover:text-blue-600 transition"
                  >
                    <User size={18} />
                    <span>Connexion</span>
                  </button>
                  <button
                    onClick={() => navigate('/signup')}
                    className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition font-medium"
                  >
                    S'inscrire
                  </button>
                </>
              )}

              {user && isCustomer && !isAdmin && (
                <>
                  <button
                    onClick={() => navigate('/dashboard')}
                    className="flex items-center space-x-1 text-gray-700 hover:text-blue-600 transition"
                  >
                    <User size={18} />
                    <span>Mon Compte</span>
                  </button>
                  <button
                    onClick={signOut}
                    className="flex items-center space-x-1 text-red-600 hover:text-red-700 transition"
                  >
                    <LogOut size={18} />
                    <span>Déconnexion</span>
                  </button>
                </>
              )}

              {isAdmin && (
                <>
                  <button
                    onClick={() => navigate('/admin')}
                    className="text-gray-700 hover:text-blue-600 transition font-medium"
                  >
                    Admin
                  </button>
                  <button
                    onClick={signOut}
                    className="flex items-center space-x-1 text-red-600 hover:text-red-700 transition"
                  >
                    <LogOut size={18} />
                    <span>Déconnexion</span>
                  </button>
                </>
              )}
            </div>
          </div>

          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMenuOpen && (
          <nav className="md:hidden py-4 border-t space-y-2">
            {!user && (
              <>
                <button
                  onClick={() => {
                    navigate('/login');
                    setIsMenuOpen(false);
                  }}
                  className="flex items-center space-x-2 w-full text-left py-2 px-4 text-gray-700 hover:bg-gray-50 rounded-lg transition"
                >
                  <User size={18} />
                  <span>Connexion</span>
                </button>
                <button
                  onClick={() => {
                    navigate('/signup');
                    setIsMenuOpen(false);
                  }}
                  className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition font-medium"
                >
                  S'inscrire
                </button>
              </>
            )}

            {user && isCustomer && !isAdmin && (
              <>
                <button
                  onClick={() => {
                    navigate('/dashboard');
                    setIsMenuOpen(false);
                  }}
                  className="flex items-center space-x-2 w-full text-left py-2 px-4 text-gray-700 hover:bg-gray-50 rounded-lg transition"
                >
                  <User size={18} />
                  <span>Mon Compte</span>
                </button>
                <button
                  onClick={() => {
                    signOut();
                    setIsMenuOpen(false);
                  }}
                  className="flex items-center space-x-2 w-full text-left py-2 px-4 text-red-600 hover:bg-red-50 rounded-lg transition"
                >
                  <LogOut size={18} />
                  <span>Déconnexion</span>
                </button>
              </>
            )}

            {isAdmin && (
              <>
                <button
                  onClick={() => {
                    navigate('/admin');
                    setIsMenuOpen(false);
                  }}
                  className="block w-full text-left py-2 px-4 text-gray-700 hover:bg-gray-50 rounded-lg transition"
                >
                  Admin
                </button>
                <button
                  onClick={() => {
                    signOut();
                    setIsMenuOpen(false);
                  }}
                  className="flex items-center space-x-2 w-full text-left py-2 px-4 text-red-600 hover:bg-red-50 rounded-lg transition"
                >
                  <LogOut size={18} />
                  <span>Déconnexion</span>
                </button>
              </>
            )}
          </nav>
        )}
      </div>
    </header>
  );
}
